import { useState } from "react";
import { MessagesContext } from "../Context/MessagesContext";

export function MessagesState(props) {
	const [messages, setMessages] = useState([]);
	const [inputBoxVisible, setInputBoxVisible] = useState(false);
	const [sendDataFlag, setSendDataFlag] = useState(false);
	return (
		<MessagesContext.Provider
			value={{
				messages,
				setMessages,
				inputBoxVisible,
				setInputBoxVisible,
				sendDataFlag,
				setSendDataFlag,
			}}
		>
			{props.children}
		</MessagesContext.Provider>
	);
}
